// removed by extract-text-webpack-plugin
module.exports = {"m-accepted-card-types":"_1TLyvBC4hkTfx4llv3T_6p"};


//////////////////
// WEBPACK FOOTER
// ./shared/components/PaymentOption/AcceptedCardTypes.scss
// module id = 969
// module chunks = 0